import { createApi } from '@reduxjs/toolkit/query/react'
import { baseQueryConfig } from '@src/lib/api'

export const dealersApi = createApi({
  reducerPath: 'dealersApi',
  baseQuery: baseQueryConfig('/dealers'),
  tagTypes: [],
  endpoints: () => ({
    
  })
})

// eslint-disable-next-line no-empty-pattern
export const {

} = dealersApi